module.exports = __webpack_public_path__ + "static/media/faq.cce9f042.svg";